export var VariableDataType;
(function (VariableDataType) {
    VariableDataType[VariableDataType["Int32"] = 1] = "Int32";
    VariableDataType[VariableDataType["Float"] = 2] = "Float";
    VariableDataType[VariableDataType["Bool"] = 4] = "Bool";
    VariableDataType[VariableDataType["String"] = 8] = "String";
})(VariableDataType || (VariableDataType = {}));
